var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutgoingTx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 13.05C17.7 12.9 17.85 12.75 17.85 12.6C18 12.45 18 12.15 18 12C18 11.85 18 11.55 17.85 11.4C17.7 11.25 17.7 11.1 17.55 10.95L11.55 4.95C10.95 4.35 10.05 4.35 9.45 4.95C8.85 5.55 8.85 6.45 9.45 7.05L12.9 10.5H1.5C0.6 10.5 0 11.1 0 12C0 12.9 0.6 13.5 1.5 13.5H12.9L9.45 16.95C8.85 17.55 8.85 18.45 9.45 19.05C10.05 19.65 10.95 19.65 11.55 19.05L17.55 13.05Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.5C13.5 2.4 14.1 3 15 3H18C19.65 3 21 4.35 21 6V18C21 19.65 19.65 21 18 21H15C14.1 21 13.5 21.6 13.5 22.5C13.5 23.4 14.1 24 15 24H18C21.3 24 24 21.3 24 18V6C24 2.7 21.3 0 18 0H15C14.1 0 13.5 0.6 13.5 1.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingTx);
export default __webpack_public_path__ + "static/media/outgoingTX.d6002de4ce3eda62d82898942bf61008.svg";
export { ForwardRef as ReactComponent };